import { useMemo, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { Seo } from '@/components/Seo'
import ProductCard from '@/components/ProductCard'
import ProductFilters from '@/components/ProductFilters'
import { Skeleton } from '@/components/ui/skeleton'

const ALL = 'Tất cả'

export default function Shop() {
  const [active, setActive] = useState(ALL)

  const categories = useQuery({ queryKey: ['categories'], queryFn: () => api.categories.list() })
  const products = useQuery({ queryKey: ['products'], queryFn: () => api.products.list() })

  const names = useMemo(() => (categories.data ?? []).map((c) => c.name), [categories.data])

  // Lọc ở client: danh mục đã tải sẵn cùng sản phẩm, nên đổi tab không cần
  // chờ thêm một vòng mạng nữa.
  const byId = useMemo(() => {
    const map = new Map<string, string>()
    for (const c of categories.data ?? []) map.set(c.id, c.name)
    return map
  }, [categories.data])

  const visible = useMemo(() => {
    const rows = products.data ?? []
    if (active === ALL) return rows
    return rows.filter((p) => (p.categoryId ? byId.get(p.categoryId) === active : false))
  }, [products.data, active, byId])

  return (
    <>
      <Seo title="Cửa hàng — LumiSkin" />

      <section data-upbo-src="src/pages/Shop.tsx:37" className="mx-auto w-full max-w-6xl px-6 pt-16 pb-20">
        <h1 data-upbo-src="src/pages/Shop.tsx:38" className="text-4xl font-semibold tracking-[-0.02em] text-[#5f3f38]">Cửa hàng</h1>
        <p data-upbo-src="src/pages/Shop.tsx:39" className="mt-3 max-w-xl text-[#9c7a72]">
          Chăm sóc da, trang điểm và nước hoa — chọn theo danh mục bên dưới.
        </p>

        <div data-upbo-src="src/pages/Shop.tsx:43" className="mt-8">
          <ProductFilters
            categories={names}
            activeCategory={active}
            onChange={setActive}
            allLabel={ALL}
          />
        </div>

        <div data-upbo-src="src/pages/Shop.tsx:52" className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {products.isLoading &&
            [0, 1, 2, 3, 4, 5].map((i) => <Skeleton key={i} className="aspect-[3/4] rounded-2xl" />)}

          {visible.map((product) => <ProductCard key={product.id} product={product} />)}

          {!products.isLoading && visible.length === 0 && (
            <p data-upbo-src="src/pages/Shop.tsx:59" className="text-sm text-[#9c7a72]">Chưa có sản phẩm nào trong danh mục này.</p>
          )}
        </div>
      </section>
    </>
  )
}
